import React from "react";
import "../css/VariantInfo.css";
import DOMPurify from "dompurify";


const VariantInfo = ({ variantDetails }) => {

  const difficultyLevels = [
    { value: 1, label: "🟢 Łatwa" },
    { value: 2, label: "🟡 Łatwa/średnia" },
    { value: 3, label: "🟠 Średnio wymagająca" },
    { value: 4, label: "🔴 Wymagająca" },
    { value: 5, label: "⚫ Bardzo trudna" },
  ];
  
  const tripTypes = [
    { value: 1, label: "🪶 Na lekko" },
    { value: 2, label: "🥾 Wędrowna z plecakiem" },
    { value: 3, label: "🛶 Spływ kajakowy" },
  ]

  

  const formatDateTime = (date) =>
    date
      ? new Date(date).toLocaleDateString("pl-PL", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-";

      const formatDate = (date) =>
        date
          ? new Date(date).toLocaleDateString("pl-PL", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "-";

      const renderRow = (label, value) => (
        <div className="info-row">
          <div className="info-label">{label}</div>
          <div className="info-value">
            {parseFormattedText(value)}
          </div>
        </div>
      );

  const tripType = variantDetails.tripType ? (
    <div className="info-row">
      <div className="info-label">Typ wycieczki</div>
      <div className="info-value">
        <strong>{tripTypes.find(t => t.value === variantDetails.tripType)?.label}</strong>
        <div>{parseFormattedText(variantDetails.tripTypeDescription)}</div>
      </div>
    </div>
  ) : null;

  const difficultyLevel = variantDetails.difficultyLevel ? (
    <div className="info-row">
      <div className="info-label">Poziom trudności</div>
      <div className="info-value">
        <strong>{difficultyLevels.find(d => d.value === variantDetails.difficultyLevel)?.label}</strong>
        <div>{parseFormattedText(variantDetails.difficultyLevelDescription)}</div>
      </div>
    </div>
  ) : null;

  const calculateFinalPaymentDate = (startDate, finalPaymentDate) => {
    if (finalPaymentDate) {
      return new Date(finalPaymentDate);
    }

    const date = new Date(startDate);
    date.setDate(date.getDate() - 3);
    return date;
  };

  return (
    <div className="variant-info">
    {tripType}
    {difficultyLevel}
    {renderRow("Osoby koordynujące", variantDetails.coordinators)}
    {renderRow("E-mail kontaktowy", variantDetails.emailContact)}
    {renderRow("Spodziewana liczebność grupy", variantDetails.capacity)}
    {renderRow("Data rozpoczęcia", formatDateTime(variantDetails.startDate))}
    {renderRow("Data zakończenia", formatDateTime(variantDetails.endDate))}
    {renderRow("Miejsce zbiórki", variantDetails.place)}
    {renderRow("Dojazd", variantDetails.transport)}
    {
    (variantDetails.price > 0) && <p className="solidarity-info">
        Chcesz pojechać z nami na wycieczkę, ale nie wiesz, czy Twój domowy budżet to wytrzyma? <strong>Fundusz Solidarnościowy</strong> jest dla Ciebie! Zapewniamy wsparcie do 75% kosztów ceny wyjazdu. Co musisz zrobić, aby dostać dofinansowanie? 
        <a href="https://www.teczowadruzyna.org/wspieraj/fundusz-solidarno%C5%9Bciowy" target="_blank" rel="noopener noreferrer"> Kliknij tutaj</a>, aby przejść na naszą stronę internetową.
    </p>
    }
      {renderRow("Cena wydarzenia", variantDetails.price? variantDetails.price + " zł" : null)}
      {renderRow("Kwota przedpłaty", variantDetails.prePaymentPrice ? variantDetails.prePaymentPrice + " zł" : null)}
      {
        (variantDetails.prePaymentPrice > 0) && <p className="prepayment-info">
         Przedpłaty należy dokonać w ciągu trzech dni roboczych od dnia otrzymania wstępnego potwierdzenia rezerwacji, lecz nie później niż ostateczny termin płatności całej ceny, tzn. do dnia <strong>{formatDate(calculateFinalPaymentDate(variantDetails.startDate, variantDetails.finalPaymentDate))}</strong>, przelewem na konto Stowarzyszenia Tęczowa Drużyna. Dane do przelewu prześlemy na podany adres email.
      </p>
      }
      {renderRow("Cena zawiera", variantDetails.priceIncludes)}
      {renderRow("Cena nie zawiera", variantDetails.priceNotIncludes)}
      {renderRow("Wymagane dokumenty", variantDetails.requiredDocuments)}
      {renderRow("Informacja dla osób o ograniczonej sprawności ruchowej",variantDetails.peopleWithDisabilitesInfo)}
      {renderRow("Informacje o zwierzętach", variantDetails.petsInfo)}
      {renderRow("Dodatkowe informacje", variantDetails.additionalInfo)}
      {renderRow("Wymagania językowe",variantDetails.languageRequirements)}
      {renderRow("Ubezpieczenie", variantDetails.insuranceDetails)}
    </div>
  );
};

export default VariantInfo;

const isLikelyHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const parseFormattedText = (input) => {
  if (input === null || input === undefined) return "-";
  if (typeof input !== "string") return input;

   if (isLikelyHtml(input)) {
    const safe = DOMPurify.sanitize(input, {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["class", "target", "rel"], 
    });
    return <div dangerouslySetInnerHTML={{ __html: safe }} />;
  }

  const lines = input.split("\n");
  const elements = [];
  let currentList = [];

  const formatContent = (text) => {
    const parts = text.split(/(<link>[^<]+<\/link>|\*\*[^*]+\*\*)/g);

    return parts.map((part, i) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={i}>{part.slice(2, -2)}</strong>;
      } else if (part.startsWith("<link>") && part.endsWith("</link>")) {
        const url = part.slice(6, -7).trim();
        return (
          <a key={i} href={url} target="_blank" rel="noopener noreferrer">
            Link
          </a>
        );
      }
      return <React.Fragment key={i}>{part}</React.Fragment>;
    });
  };

  lines.forEach((line, index) => {
    const trimmed = line.trim();

    // tylko jeśli linia zaczyna się od "* " (gwiazdka + spacja)
    if (/^\*\s+/.test(trimmed)) {
      currentList.push(
        <li key={`li-${index}`}>{formatContent(trimmed.replace(/^\*\s+/, ""))}</li>
      );
    } else {
      if (currentList.length > 0) {
        elements.push(
          <ul key={`ul-${index}`} style={{ margin: "unset", paddingLeft: "20px" }}>
            {currentList}
          </ul>
        );
        currentList = [];
      }
      if (trimmed !== "") {
        elements.push(<div key={`p-${index}`}>{formatContent(trimmed)}</div>);
      }
    }
  });

  if (currentList.length > 0) {
    elements.push(
      <ul key="ul-last" style={{ margin: "unset", paddingLeft: "20px" }}>
        {currentList}
      </ul>
    );
  }

  return elements.length > 0 ? elements : "-";
};

